import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface GLCodeDepartment {
  glCdId: number;
  departmentId: number;
  departmentName: string;
}

export interface GLCodeDepartmentsResponse {
  glCdId: number;
  departmentId: number;
  departmentName: string;
}

const useGlCodeDepartmentsApi = (companyId: string) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<GLCodeDepartmentsResponse[]>(
        api.glCodeDepartments(companyId)
      );
      return res.data    
      
    } catch (error) {
      throw new Error(error);
    }
  }, [companyId]);

  const { isLoading, value, execute } = useAsync(
    call,
    false,
    undefined,    
  );

  return {
    isLoading,
    glCodeDepartments: value,
    getGlCodeDepartments: execute,
  };
};

export default useGlCodeDepartmentsApi;
